<div class="flex h-full min-h-0 w-full items-center justify-center">
  <div
    class="bg-m0 group flex h-full max-h-full w-full max-w-[calc(66vw-5rem)] flex-col"
  >
    <div class="mx-5 flex min-h-0 flex-1 flex-col">
      <div
        class="text-s1 mb-5 mt-2 flex w-full flex-shrink-0 flex-row items-center justify-start"
      >
        <div class="flex flex-1 flex-row items-center justify-start"></div>

        <div class="flex flex-1 flex-row items-center justify-end">
          <div
            *ngIf="!!query"
            class="ml-5 flex flex-row items-center justify-end"
          >
            <m-query-status
              [query]="query"
              [showDataRowsLength]="true"
              [showLastCompleteDuration]="true"
              [completedWord]="'Completed'"
            ></m-query-status>
          </div>

          <button
            data-cy="explorerChartRunButton"
            class="text-m0 ml-5 flex h-12 w-24 flex-shrink-0 select-none items-center justify-center rounded text-base font-medium focus:outline-none"
            [ngClass]="{
              'bg-s400 cursor-default': query?.status === queryStatusRunning,
              'bg-m600 cursor-pointer': query?.status !== queryStatusRunning
            }"
            [disabled]="query?.status === queryStatusRunning"
            (click)="run()"
          >
            <div>Run</div>
          </button>

          <button
            data-cy="explorerChartExploreButton"
            class="text-m0 bg-m600 ml-5 h-12 cursor-pointer select-none rounded px-6 text-base font-medium focus:outline-none"
            (click)="explore({ event: $event })"
          >
            Explore
          </button>
        </div>
      </div>

      <div
        class="text-s1 mb-10 flex flex-shrink-0 flex-row items-start justify-start text-lg"
      >
        <div
          class="text-s1 flex max-h-[60px] w-2/3 min-w-0 flex-col items-center justify-start"
        >
          <div
            class="mt-[2px] line-clamp-2 flex max-h-[60px] select-none flex-col items-center text-center text-xl font-semibold"
          >
            {{ title }}
          </div>
        </div>
      </div>

      <div
        class="bg-m0 flex min-h-0 w-full flex-grow cursor-default justify-start overflow-auto rounded"
        (click)="stopClick({ event: $event })"
      >
        <m-chart-view
          #chartView
          *ngIf="!!qData && !!mconfig?.mconfigId"
          [ngClass]="{
            'w-full pt-3':
              mconfig?.chart.type === chartTypeEnumTable ||
              mconfig?.chart.type === chartTypeEnumPivotTable,
            'border-s300 aspect-[3/1] w-2/3 border pb-6 pt-5':
              mconfig?.chart.type !== chartTypeEnumTable &&
              mconfig?.chart.type !== chartTypeEnumPivotTable,
            'max-w-max':
              mconfig?.chart.type === chartTypeEnumTable &&
              isSelectValid === true &&
              mconfig?.chart.isValid === true &&
              qData?.length > 0
          }"
          class="h-full"
          [isTableHeaderWide]="false"
          [modelType]="mconfig.modelType"
          [mconfigFields]="mconfig.fields"
          [mconfigTimezone]="mconfig.timezone"
          [qData]="qData"
          [chart]="mconfig.chart"
          [isAnimation]="false"
          [isStoreModel]="mconfig?.modelType === modelTypeStore"
          [queryStatus]="query?.status"
          [chartInstanceId]="'explorer-chart-mconfig-id-' + mconfig?.mconfigId"
        ></m-chart-view>
      </div>

      <div
        *ngIf="
          (isData && mconfig?.fields?.length > 0) ||
          mconfig?.filters?.length > 0 ||
          isGivens === true
        "
        class="mt-10 flex max-h-[24%] min-h-[24%] flex-row"
      >
        <div
          *ngIf="isData && mconfig?.fields?.length > 0"
          class="flex w-full max-w-max flex-1 overflow-auto"
        >
          <m-main-table
            class="block h-full w-full"
            [isTableHeaderWide]="false"
            [isEdit]="false"
            [isFormat]="isFormat"
            [mconfig]="mconfig"
            [qData]="qData"
            [mconfigFields]="mconfig?.fields"
          ></m-main-table>
        </div>

        <div
          class="ml-10 flex flex-shrink-0 flex-row items-start"
          *ngIf="mconfig?.filters?.length > 0"
        >
          <m-bricks
            class="flex max-h-[150px] max-w-max overflow-auto"
            [extendedFilters]="mconfig.extendedFilters"
            [listen]="tile.listen"
            [isKeepBackgroundColor]="false"
          ></m-bricks>
        </div>

        <div
          class="border-s300 ml-10 flex max-h-[150px] min-w-0 flex-1 overflow-auto rounded border bg-white p-3"
          *ngIf="isGivens === true"
        >
          <pre class="text-s1 text-sm leading-6">{{ appliedGivensJson }}</pre>
        </div>
      </div>

      <div class="mt-7 flex cursor-default flex-row items-center justify-end">
        <div class="flex flex-row items-center justify-end">
          <div
            *ngIf="mconfig?.fields?.length > 0 && isData"
            class="flex h-11 cursor-pointer flex-row items-center"
            (click)="toggleFormat()"
          >
            <div class="text-s1 flex h-11 select-none items-center text-base"
              >Format
            </div>

            <ui-switch
              class="mb-1 ml-5 flex flex-row items-center"
              [checked]="isFormat"
              color="#64BD63"
            ></ui-switch>
          </div>

          <div
            class="ml-10 cursor-pointer select-none text-lg focus:outline-none"
            (click)="toggleGivens()"
            [ngClass]="{
              'text-s400': isGivens === false,
              'text-green-600': isGivens === true
            }"
            >GIVENS</div
          >

          <div
            *ngIf="
              mconfig?.fields?.length > 0 &&
              mconfig?.chart.type === chartTypeEnumTable
            "
            class="ml-10 flex h-11 cursor-pointer flex-row items-center"
            (click)="toggleData()"
          >
            <div class="text-s1 flex h-11 select-none items-center text-base"
              >Data
            </div>

            <ui-switch
              class="mb-1 ml-5 flex flex-row items-center"
              [checked]="isData"
              color="#64BD63"
            ></ui-switch>
          </div>

          <div class="text-s400 ml-10 select-none text-base font-semibold"
            >Model:</div
          >

          <div class="ml-2 flex flex-row items-center">
            <div class="group select-none text-base focus:outline-none">
              <span class="ml-[5px] font-semibold">{{
                mconfig?.modelLabel | capitalize
              }}</span>

              <span class="text-s400 ml-[5px]"
                >- {{ query?.connectionType }}</span
              >
            </div>
          </div>

          <div class="text-s400 ml-10 select-none text-base font-semibold"
            >Timezone:</div
          >

          <div class="text-s400 ml-2 select-none text-base focus:outline-none">
            {{ mconfig?.timezone | capitalize }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="nav$ | async"></div>
